var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.967,
    height: 20,
    viewBox: "0 0 19.967 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-195.856 -195.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M208.862,215.592h-6.019c-.122-.011-.245-.028-.367-.031a11.311,11.311,0,0,1-2.365-.241,5.121,5.121,0,0,1-3.619-2.889,7.182,7.182,0,0,1-.6-3.042c-.022-2.156-.042-4.311-.032-6.467a13.021,13.021,0,0,1,.262-3.087,5.11,5.11,0,0,1,3.169-3.724,7.7,7.7,0,0,1,2.851-.486c2.032-.022,4.064-.039,6.1-.032a15.151,15.151,0,0,1,3.19.226,5.121,5.121,0,0,1,3.981,3.421,8.236,8.236,0,0,1,.409,2.807c.007,2.306.014,4.611,0,6.917a13.465,13.465,0,0,1-.158,1.963,5.2,5.2,0,0,1-1.849,3.317,5.964,5.964,0,0,1-3.521,1.267C209.809,215.544,209.335,215.566,208.862,215.592Zm-3.01-1.768v-.031c.528,0,1.056.016,1.583,0,1.138-.041,2.284-.027,3.41-.169A3.261,3.261,0,0,0,213.8,211a8.728,8.728,0,0,0,.213-1.9q.055-2.783.034-5.568a26.515,26.515,0,0,0-.152-2.9,3.313,3.313,0,0,0-2.784-3.016,11.79,11.79,0,0,0-2.115-.191q-2.813-.041-5.627-.009a19.665,19.665,0,0,0-2.607.167,3.283,3.283,0,0,0-2.874,2.723,11.175,11.175,0,0,0-.193,2q-.051,2.422-.029,4.845c.012,1.119.041,2.241.15,3.353a3.308,3.308,0,0,0,1.685,2.668,4.323,4.323,0,0,0,2.038.538C202.974,213.763,204.413,213.788,205.852,213.823Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M319.791,324.812a5.14,5.14,0,1,1,5.145,5.142A5.143,5.143,0,0,1,319.791,324.812Zm5.141,3.331a3.33,3.33,0,1,0-3.33-3.325A3.32,3.32,0,0,0,324.932,328.143Z",
    transform: "translate(-119.082 -119.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M558.176,283.907a1.2,1.2,0,0,1-.056,2.393,1.2,1.2,0,1,1,.056-2.393Z",
    transform: "translate(-346.955 -84.857)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.5c6afb270d98639bf31a43580635458b.svg";
export { ForwardRef as ReactComponent };